import getLang from 'I18n/utils/getLang';
import { create } from 'zustand';
const initialState = {
  paramLanguage: null,
  lessonLanguage: null
};
export const useAcademyLanguage = create(set => Object.assign({}, initialState, {
  setLanguages: languages => set(Object.assign({}, languages)),
  resetLanguages: () => set(Object.assign({}, initialState))
}));
export const getAcademyLanguage = (win = window) => {
  const {
    paramLanguage,
    lessonLanguage
  } = useAcademyLanguage.getState();
  const params = new URLSearchParams(win.location.search);
  const searchLanguage = params.get('language');
  if (lessonLanguage) return lessonLanguage;
  if (paramLanguage) return paramLanguage;

  if (searchLanguage) {
    return searchLanguage;
  }

  try {
    return getLang();
  } catch (e) {
    return 'en';
  }
};